
      var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLeftArrowPressed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  rx: 30,
  transform: "matrix(1 0 0 -1 0 60)",
  fill: "#fff",
  fillOpacity: 0.2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#leftArrowPressed_ab3dfb1d71e23989__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.931 41.948a1.74 1.74 0 0 1 .082 2.494 1.827 1.827 0 0 1-2.37.222l-.174-.141-14.4-13.236a1.74 1.74 0 0 1-.151-2.418l.15-.156 14.4-13.236a1.825 1.825 0 0 1 2.545.08 1.74 1.74 0 0 1 .073 2.334l-.155.161-13 11.948 13 11.948Z",
  fill: "#E1E1E1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "leftArrowPressed_ab3dfb1d71e23989__a",
  x: 15.5,
  y: 13,
  width: 24,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_15724_140698"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_15724_140698",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect width=\"60\" height=\"60\" rx=\"30\" transform=\"matrix(1 0 0 -1 0 60)\" fill=\"white\" fill-opacity=\"0.2\"/>\r\n<g filter=\"url(#filter0_d_15724_140698)\">\r\n<path d=\"M35.9311 41.9479C36.6563 42.6145 36.6931 43.7312 36.0132 44.4422C35.3855 45.0986 34.3667 45.1798 33.6432 44.6641L33.4689 44.5227L19.0689 31.2874C18.3645 30.64 18.3142 29.5759 18.918 28.869L19.0689 28.7126L33.4689 15.4773C34.1941 14.8107 35.3332 14.8467 36.0132 15.5578C36.6408 16.2141 36.6577 17.2161 36.0862 17.8907L35.9311 18.0521L22.9316 30L35.9311 41.9479Z\" fill=\"#E1E1E1\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_15724_140698\" x=\"15.5\" y=\"13\" width=\"24\" height=\"36\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"1\"/>\r\n<feGaussianBlur stdDeviation=\"1.5\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_15724_140698\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_15724_140698\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/leftArrowPressed.ab3dfb1d71e239892f7de9200315ff15.svg"),
        {
          React: SvgLeftArrowPressed,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      